interface Brand {
  id: number;
  name: string;
}

interface Category {
  id: number;
  name: string;
}

interface ProductsFilterSidebarProps {
  brands: Brand[];
  categories: Category[];
  selectedBrand: string;
  selectedCategory: string;
  selectedMinStock: string;
  onBrandChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onMinStockChange: (value: string) => void;
  onClearAll: () => void;
}

const ProductsFilterSidebar = ({
  brands,
  categories,
  selectedBrand,
  selectedCategory,
  selectedMinStock,
  onBrandChange,
  onCategoryChange,
  onMinStockChange,
  onClearAll,
}: ProductsFilterSidebarProps) => {
  const hasActiveFilters = selectedBrand || selectedCategory || selectedMinStock;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 sticky top-24">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-bold text-gray-900">Filters</h3>
        {hasActiveFilters && (
          <button
            onClick={onClearAll}
            className="text-sm text-red-600 hover:text-red-700 font-medium cursor-pointer"
          >
            Clear All
          </button>
        )}
      </div>

      <div className="space-y-6">
        {/* Brand Filter */}
        <div>
          <h4 className="text-sm font-semibold text-gray-900 mb-3">Brand</h4>
          <div className="space-y-2 max-h-48 overflow-y-auto">
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="brand"
                value=""
                checked={!selectedBrand}
                onChange={() => onBrandChange('')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">All Brands</span>
            </label>
            {brands.map(brand => (
              <label
                key={brand.id}
                className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors"
              >
                <input
                  type="radio"
                  name="brand"
                  value={brand.id}
                  checked={selectedBrand === String(brand.id)}
                  onChange={() => onBrandChange(String(brand.id))}
                  className="w-4 h-4 text-blue-600 cursor-pointer"
                />
                <span className="text-sm text-gray-700">{brand.name}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Category Filter */}
        <div className="pt-6 border-t border-gray-200">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">Category</h4>
          <div className="space-y-2 max-h-48 overflow-y-auto">
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="category"
                value=""
                checked={!selectedCategory}
                onChange={() => onCategoryChange('')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">All Categories</span>
            </label>
            {categories.map(category => (
              <label
                key={category.id}
                className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors"
              >
                <input
                  type="radio"
                  name="category"
                  value={category.id}
                  checked={selectedCategory === String(category.id)}
                  onChange={() => onCategoryChange(String(category.id))}
                  className="w-4 h-4 text-blue-600 cursor-pointer"
                />
                <span className="text-sm text-gray-700">{category.name}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Minimum Stock Filter */}
        <div className="pt-6 border-t border-gray-200">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">Minimum Stock</h4>
          <div className="space-y-2">
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="minStock"
                value=""
                checked={!selectedMinStock}
                onChange={() => onMinStockChange('')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">All Stock</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="minStock"
                value="10"
                checked={selectedMinStock === '10'}
                onChange={() => onMinStockChange('10')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">≥ 10 cartons</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="minStock"
                value="50"
                checked={selectedMinStock === '50'}
                onChange={() => onMinStockChange('50')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">≥ 50 cartons</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
              <input
                type="radio"
                name="minStock"
                value="100"
                checked={selectedMinStock === '100'}
                onChange={() => onMinStockChange('100')}
                className="w-4 h-4 text-blue-600 cursor-pointer"
              />
              <span className="text-sm text-gray-700">≥ 100 cartons</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsFilterSidebar;
